export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Razón de espera\",\n    \"label_other\": \"{{count}} razones de espera\"\n}\n"